import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import Preloader from "../layout/Preloader";
import queryString from "query-string";
import useForm from "../../hooks/useForm";
import usePageTitle from "../../hooks/usePageTitle";

const ResetPassword = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);

  const { getConfigValueByCode, getConfigValueByName, loadConfig, loaded } =
    configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { loading, requestPasswordReset, validateResetPasswordLink } =
    authContext;
  // const { reset_token } = useParams();
  const history = useHistory();
  const { search } = useLocation();
  const values = queryString.parse(search);
  const reset_token = values.token;

  const [showForm, setShowForm] = useState(false);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Reset Password",
  });

  useEffect(() => {
    clearAlerts();
    const checkLinkIsValid = async () => {
      try {
        const res = await validateResetPasswordLink(reset_token);
        if (res) {
          setShowForm(true);
        } else if (res && res.msgCode) {
          displayLinkError(res.msgCode);
          setShowForm(false);
        } else {
          displayLinkError();
          setShowForm(false);
        }
      } catch (err) {
        console.log("TOKEN VALID RESP ERROR", err);
        displayLinkError(406);
        setShowForm(false);
      }
    };
    const getConfigDetails = async () => {
      try {
        const res = await loadConfig();
        if (res) {
          if (reset_token) checkLinkIsValid();
        }
      } catch (err) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger");
      }
    };
    getConfigDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const displayLinkError = (errCode) => {
    const msg = getConfigValueByCode(
      "generalConfig",
      "RESPONSE_MSG",
      errCode ? errCode : 406
    );
    clearAlerts();
    setAlert(msg, "danger");
    history.push("/");
  };

  const [userinfo, setUserinfo] = useState({
    newpassword: "",
    confirmpassword: "",
  });
  const [labels, setLabels] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });

  useEffect(() => {
    if (loaded) {
      let newPassword = getConfigValueByName(
        "generalConfig",
        "Label",
        "label.newPassword"
        // label.newPassword
      );
      let confirmNewPassword = getConfigValueByName(
        "generalConfig",
        "Label",
        "label.confirmNewPassword"
      );
      setLabels({
        ...labels,
        newPassword,
        confirmNewPassword,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  const { newpassword, confirmpassword } = userinfo;
  const newpasswordRef = useRef(null);
  const confirmpasswordRef = useRef(null);

  const onChange = (e) => {
    setUserinfo({ ...userinfo, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    clearAlerts();
    e.preventDefault();
    // if (newpassword === "" || confirmpassword === "") {
    //   // clearErrors();
    //   setAlert("Please fill in all fields", "danger");
    // } else {
    // clearAlerts();
    const userinfo = {
      newpassword,
      confirmpassword,
    };
    try {
      const res = await requestPasswordReset(userinfo, reset_token);
      if (res && res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        setAlert(msg, res.status === "ERROR" ? "danger" : "info");
      } else {
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 471);
        setAlert(msg, "info");
      }
    } catch (err) {
      let errMsg = getConfigValueByCode("generalConfig", "RESPONSE_MSG", 475);
      console.log("Error::::", JSON.stringify(err));
      setAlert(errMsg, "danger");
    }
    history.push("/");
    // }
  };
  // const resendLink = () => {
  //   /* To-DO : Call resentLink API */
  //   console.log("Resend the link");
  // };

  const newpassRef = useRef();
  newpassRef.current = newpassword;
  const isConfirmPasswordMatching = (value) => {
    console.log("Confirm pass to match", value);
    let isMatching = false;
    if (newpassRef.current) isMatching = newpassRef.current === value;

    return !isMatching ? " is not matching" : "";
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
  } = useForm({
    inputList: {
      newpassword: newpasswordRef,
      confirmpassword: confirmpasswordRef,
    },
    customRules: {
      confirmpassword: isConfirmPasswordMatching,
    },
    screenName: "reset_pasword",
  });

  const formData = !(newpassword === "" && confirmpassword === "");
  useEffect(() => {
    let isValid;
    if (newpassword !== "" && confirmpassword !== "") {
      isValid = validateAllFields();
      setIsFormValid(isValid);
    } else {
      setIsFormValid(false);
    }
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userinfo]);

  return (
    <Fragment>
      <Popup role="alert" aria-relevant="all" />
      {loading && <Preloader />}
      <div
        className="publicView"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        {!loading && showForm && (
          <div>
            <div className="publicView__pageTitle">
              <h1> RESET ACCOUNT PASSWORD</h1>
              <div className="publicView__pageTitle__note">
                {/* <span className="required">*</span>denotes a required field */}
              </div>
            </div>

            <div className="publicView__subPageTitle">Create New Password</div>

            <div className="publicView__subPageTitleInfo">
              Type and confirm a new secure password for the account.
            </div>

            <div className="publicView__formBody">
              <form autoComplete="off" noValidate>
                <div className="publicView__formGroup">
                  <label htmlFor="newpassword">
                    {labels.newPassword}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </label>
                  <input
                    type="password"
                    name="newpassword"
                    className="form-control"
                    placeholder={labels.newPassword}
                    onChange={onChange}
                    onBlur={validateField}
                    ref={newpasswordRef}
                    aria-required="true"
                    autoComplete="new-password"
                  />
                  <div></div>
                </div>
                <div className="publicView__formGroup">
                  <label htmlFor="confirmpassword">
                    {labels.confirmNewPassword}
                    <span className="required" aria-label="Input required">
                      (*Required)
                    </span>
                    :{" "}
                  </label>
                  <input
                    type="password"
                    name="confirmpassword"
                    className="form-control"
                    placeholder={labels.confirmNewPassword}
                    onChange={onChange}
                    onBlur={validateField}
                    ref={confirmpasswordRef}
                    aria-required="true"
                    autoComplete="new-password"
                  />
                  <div></div>
                </div>
                <div className="publicView__formGroup">
                  <input
                    type="submit"
                    value="CHANGE PASSWORD"
                    className="btn btn-block btn-primary publicView__button"
                    onClick={onSubmit}
                    disabled={!isFormValid || !formData}
                  />
                  <div></div>
                  <div></div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ResetPassword;
